import downloadJS from 'downloadjs';
import commonUtils from './common';

const manualDownloadTargetBlank = (url: string, name?: string) => {
  const link = document.createElement('a');
  link.setAttribute('href', url);
  link.setAttribute('download', name || 'Filename.download');
  link.setAttribute('target', '_self');
  link.style.display = 'none';
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};

// const manualDownloadTargetNew = (url: string, name?: string) => {
//   const link = document.createElement('a');
//   link.setAttribute('href', url);
//   link.setAttribute('download', name || 'Filename.download');
//   link.setAttribute('target', '_new');
//   link.style.display = 'none';
//   document.body.appendChild(link);
//   link.click();
//   document.body.removeChild(link);
// };

// const deferDonwload = (url: string, name?: string) => {
//   setTimeout(() => {
//     try {
//       window.open(url);
//     } catch (err) {}
//   }, 100);
// };

export const browserDownload = (url: string, name?: string) => {
  const fixedUrl = !url.startsWith('http') ? 'http://' + url : url;
  const downloadMethods = [manualDownloadTargetBlank, downloadJS];
  const res = commonUtils.tryEachUntilSuccess(downloadMethods, fixedUrl, name);
  if (!res.successes.length) {
    console.error(`Could not download file with name ${name} and url ${url}`);
  }
};

export const refreshCurrentPage = () => {
  window.location.reload(true);
};

export default {
  browserDownload,
  refreshCurrentPage,
};
